import CometMarquee from 'comet-marquee';
// import 'comet-marquee/dist/comet-marquee.css';

const clientsMarqueeArr = document.querySelectorAll('.clients-marquee');
clientsMarqueeArr.forEach((clientsMarqueeEl, i) => {
  const clientsMarquee = new CometMarquee(clientsMarqueeEl, {
    speed: window.innerWidth <= 640 ? 30 : 60,
    pauseOnHover: true,
    initialShift: true,
    pauseOnInvisible: true,
    syncPause: true,
    repeatCount: 3,
  });
})